import PropTypes from 'prop-types';
import { getImageUrl } from '@utils/imageUtils';

const Avatar = ({ 
  src, 
  name, 
  email, 
  size = 'md', 
  className = '',
  showBorder = false,
  isCurrentUser = false 
}) => {
  const getInitials = () => {
    if (!name && !email) return 'U';
    
    const displayName = name || email;
    const parts = displayName.trim().split(/\s+/);
    
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return displayName.substring(0, 2).toUpperCase();
  };

  const getGradientColor = () => {
    const str = name || email || 'User';
    let hash = 0;
    
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    const gradients = [
      'from-secondary-400 to-secondary-600',
      'from-blue-400 to-blue-600',
      'from-cyan-400 to-cyan-600',
      'from-green-400 to-green-600',
      'from-purple-400 to-purple-600',
      'from-pink-400 to-pink-600',
      'from-indigo-400 to-indigo-600',
      'from-teal-400 to-teal-600',
      'from-red-400 to-red-600',
      'from-yellow-400 to-yellow-600',
    ];
    
    const index = Math.abs(hash) % gradients.length;
    return gradients[index];
  };

  const sizeClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-10 h-10 text-sm',
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-lg',
    xl: 'w-20 h-20 text-xl',
    '2xl': 'w-24 h-24 text-2xl',
  };

  const borderClasses = showBorder 
    ? isCurrentUser 
      ? 'ring-4 ring-accent/30' 
      : 'ring-2 ring-gray-200'
    : '';

  const imageUrl = src ? getImageUrl(src) : null;

  return (
    <div className={`relative inline-block ${className}`}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={name || email || 'User'}
          className={`${sizeClasses[size]} rounded-full object-cover ${borderClasses}`}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <div
        className={`${sizeClasses[size]} bg-gradient-to-br ${getGradientColor()} rounded-full flex items-center justify-center font-bold text-white ${borderClasses} ${imageUrl ? 'hidden' : 'flex'}`}
      >
        {getInitials()}
      </div>
    </div>
  );
};

Avatar.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl']),
  className: PropTypes.string,
  showBorder: PropTypes.bool,
  isCurrentUser: PropTypes.bool,
};

export default Avatar;
